import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class ShotDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"TIR"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "TIR",
            shoter: event.detail?.shoter,
          };
    }

    get shoter() {
        return this.detail.shoter;
    }
    set shoter(value) {
        this.detail.shoter = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "shoter", "reason"].includes(key)){

            let commentaire = "Tir"

            if(this.reason)
            switch(this.reason){
                case 'cadre':
                    commentaire+=' cadré'
                break
                case 'nocadre':
                    commentaire+=' non cadré'
                break
                case 'poteau':
                    commentaire+=' sur le poteau'
                break
                case 'transversale':
                    commentaire+=' sur la barre transversale'
                break
            }

            const shoteurPlayer = getPlayer(this.shoter, match)
            const team = getTeam(this.team, match)

            if(this.shoter){
                if(shoteurPlayer){
                    commentaire += ' de '+ shoteurPlayer.lastname
                }
            }else if(team){
                commentaire += ' de '+ team.name
            }

            commentaire += "! "

            this.text = commentaire
        }
    }
}